import React from 'react';
import { motion } from 'framer-motion';

export const SolutionSection = () => {
  return (
    <section
      id="solution"
      data-testid="solution-section"
      className="py-24 md:py-32 bg-gradient-to-br from-sky-50/60 via-white to-orange-50/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl"
        >
          <span className="font-accent text-slate-400 mb-6 block" data-testid="solution-label">
            The Solution
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-slate-900 leading-tight mb-8"
            data-testid="solution-headline"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            What if your Instagram actually{' '}
            <span className="font-medium">brought customers to your door?</span>
          </h2>
          <p className="text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl mb-12">
            Big Jaguar doesn't just post for you. We build a complete growth system
            around your business — strategy, content, influencers, and optimization —
            so Instagram becomes your most reliable source of new customers.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { num: '01', label: 'Strategy' },
              { num: '02', label: 'Content' },
              { num: '03', label: 'Influencers' },
              { num: '04', label: 'Optimization' },
            ].map((item, i) => (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="text-center md:text-left"
                data-testid={`solution-pillar-${i}`}
              >
                <span
                  className="text-5xl font-light text-slate-200 block mb-2"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  {item.num}
                </span>
                <span className="text-sm font-medium text-slate-700">
                  {item.label}
                </span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
